import { render } from "./MemberTransaction.vue?vue&type=template&id=55d9e0b9&scoped=true"
import script from "./MemberTransaction.vue?vue&type=script&lang=js"
export * from "./MemberTransaction.vue?vue&type=script&lang=js"

import "./MemberTransaction.vue?vue&type=style&index=0&id=55d9e0b9&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55d9e0b9"]])

export default __exports__